import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import { ref, reactive, getCurrentInstance, onMounted } from 'vue';
import { useProductStore } from "../../../store/product"; //引入product仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { useRouter } from 'vue-router';
export default {
  name: "ProductList",
  setup: function setup() {
    var mitt = getCurrentInstance(); //调用全局事件总线的api

    var bus = mitt.appContext.config.globalProperties.mittBus;
    var store = useProductStore();
    var router = useRouter();
    onMounted(function () {
      store.getProductList1(); //通知vuex发送请求获取产品数据,初次加载页面时发送一次请求
      //接受分页器组件传过来的当前页面数值

      bus.on("getPageNo", function (pageNo) {
        if (pageNo == 1) {
          //pageNo == 1 则请求分页一的数据
          store.getProductList1();
          thisPageNo.value = 1;
        }

        if (pageNo == 2) {
          //pageNo == 2 则请求分页二的数据
          store.getProductList2();
          thisPageNo.value = 2;
        }

        if (pageNo == 3) {
          //pageNo == 3 则请求分页三的数据
          store.getProductList3();
          thisPageNo.value = 3;
        }

        if (pageNo == 4) {
          //pageNo == 3 则请求分页三的数据
          store.getProductList4();
          thisPageNo.value = 4;
        }
      });
    }); //产品数据

    var _storeToRefs = storeToRefs(store),
        productList = _storeToRefs.productList; //从仓库获取产品分页的数据
    //定义初始选择的导航是第一个


    var activeName = ref(1);
    var isOne = ref(true);
    var thisPageNo = ref(1); //初始化当前页面值
    //切换导航事件,隐藏分页器

    function changeNav(event) {
      if (event.target.id) {
        //当前id不为空
        if (event.target.id == "tab-1" || event.target.id == "pane-1") {
          //当前id为第一分类的产品id则显示分页器
          isOne.value = true;
        } else {
          //其他情况隐藏分页器
          isOne.value = false;
        }
      }
    } //跳转到产品详情页面(重开一个页面的写法||但是这样只能在哈希模式下使用)


    function goProductDetail(product) {
      var pushInfo = router.resolve({
        //通过resolve跳转可以获取跳转地址信息href
        path: "/product/productdetails",
        query: {
          id: product.pid,
          title: product.name,
          detail: JSON.stringify(product.sellDetail) //query参数传递过程中会将对象装换成[object object],将其转换为字符串即可解决

        }
      });
      window.open(pushInfo.href, '_blank'); //跳转路由并开启新的页面
    } //跳转到产品详情页面 | 不开启新页面直接跳转
    // function goProductDetail(product) {
    //     router.push({
    //         path: "/product/productdetails",
    //         query: {
    //             id: product.pid,
    //             title: product.name,
    //             detail: JSON.stringify(product.sellDetail) //query参数传递过程中会将对象装换成[object object],将其转换为字符串即可解决
    //         }
    //     })
    // }


    return {
      activeName: activeName,
      productList: productList,
      isOne: isOne,
      thisPageNo: thisPageNo,
      changeNav: changeNav,
      goProductDetail: goProductDetail
    };
  }
};